export default __webpack_public_path__ + "7fda834cee15a2f95e83ca4a49c4923f.webp";